import SelectComponent from '@componentes/select/select.component';
import React from 'react';
import { Form, Row, Col, FormGroup, Label, Button } from 'reactstrap';
import CheckBox from '@componentes/checkbox/checkbox.component';
import './recolhimento.styles.css';
import IntlMessage from '../../../helpers/intlMessage';
import { useIntl } from 'react-intl';

const RecolhimentoPage = (props) => { 
  const intl = useIntl();

	function translate(key) {
	  return intl.formatMessage({ id: key });
	}
  return (
  <div className='mv-rastreabilidade'>
    {/* <Form onSubmit={props.confirma}> */}
    <Form onSubmit={(e) => props.confirma(e)}>
      <Row>
        <Col>
          <Row>
            <Col>
              <FormGroup>
                <Label><IntlMessage id = "dashboards.examDetail.sampleOrigin"/>:</Label>
                <SelectComponent
                  options={props.setores}
                  onChange={(e) => props.atualizarState('setor', e)}
                  value={props.setor}
                  placeholder={translate("dashboards.examDetail.sampleOrigin")}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormGroup>
                <Label><IntlMessage id = "dashboards.examDetail.receivedBy"/>:</Label>
                <SelectComponent
                  options={props.usuarios}
                  onChange={(e) => props.atualizarState('usuarioRecebido', e)}
                  value={props.usuarioRecebido}
                  placeholder={translate("general.user")}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormGroup>
                <Label><IntlMessage id = "dashboards.examDetail.processFor"/>:</Label>
                <SelectComponent
                  required
                  options={props.etapas}
                  onChange={(e) => props.atualizarState('nomeEtapa', e)}
                  placeholder={translate("dashboards.examDetail.delegationTo")}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
          <Col>
            <FormGroup>
            <CheckBox
                readOnly
                label={<IntlMessage id = "general.materialArchiving.deliveredToThePatient"/>}
                onChange={props.entreguePaciente}
                entreguePaciente={props.entreguePaciente}
                //disabled={}
            />
          </FormGroup>
          </Col>
          </Row>
        </Col>
      </Row>
      <Button color='primary' className='buttonConfirma' type='submit'>
        <IntlMessage id = "dashboards.examDetails.confirm"/>
      </Button>
    </Form>
  </div>
)};

export default RecolhimentoPage;



// WEBPACK FOOTER //
// ./src/app/common/recolhimento/recolhimento.page.js